import { or, Roles } from '@/js/libs/use-auth';

// The GenAI chat rollout is permission-driven: every platform-company user
// (CompanyRole ADMIN, i.e. audienzz) has it implicitly, everyone else gets it
// when an admin grants the GEN_AI permission to their company or user. Data
// stays safe regardless of the grant: conversations are user-scoped and the
// AdConsole agent tools run with the caller's own token.
export const GEN_AI_CHAT_ROLES = or(Roles.ADMIN, Roles.GEN_AI);

// GenAI settings are open to any GenAI user for now (not just company admins):
// agents and brand kits are company-scoped server-side, so a user only ever
// manages their own company's config. MCP servers stay platform-only and are
// gated separately by canManageGlobalConfig.
export const GEN_AI_SETTINGS_ROLES = GEN_AI_CHAT_ROLES;
